export const COMPANY = {
  name: "KVC Express ApS",
  cvr: "46170903",
  phone: "29 36 87 88",
  phoneRaw: "29368788",
  email: "kontakt@kvcexpress.dk",
  location: "Rødovre, Storkøbenhavn",
  city: "2610 Rødovre",
  country: "Danmark",
  coverage: "Hele Danmark inkl. Bornholm",
  coverageShort: "Landsdækkende inkl. Bornholm",
  phoneHours: "Mandag–fredag kl. 10.00–17.00",
  emailResponse: "Vi svarer normalt inden for én hverdag.",
  tagline: "Specialiseret temperaturkontrolleret transport & faste transportaftaler",
  primaryFocus: "Professionel køle- og medicinaltransport for erhvervskunder i hele Danmark inkl. Bornholm"
};

export const NAV_LINKS = [
  {
    label: "Ydelser",
    href: "/ydelser/koeletransport",
    dropdown: [
      {
        title: "Køletransport",
        href: "/ydelser/koeletransport",
        tag: "Temperaturfølsomt",
        desc: "Specialiseret transport af kølevarer i moderne L2H2 kølebiler med fokus på driftssikkerhed."
      },
      {
        title: "Medicinaltransport",
        href: "/ydelser/medicinaltransport",
        tag: "Høj præcision",
        desc: "Transport for medicinalvirksomheder med høje krav til materiel, stabilitet og faste aftaler."
      },
      {
        title: "Fødevaretransport",
        href: "/ydelser/foedevaretransport",
        tag: "B2B Distribution",
        desc: "Erhvervstransport til fødevareproducenter, grossister og måltidskassevirksomheder."
      },
      {
        title: "Transportpartner / Underleverandør",
        href: "/ydelser/transportpartner",
        tag: "Kapacitet & Aftaler",
        desc: "Fast underleverandør for logistikoperatører og distributionshuse."
      }
    ]
  },
  {
    label: "Om KVC Express",
    href: "/om-kvc-express"
  },
  {
    label: "Vores køretøjer",
    href: "/vores-koeretoejer"
  },
  {
    label: "Kontakt",
    href: "/kontakt"
  }
];

export const FLEET_SPECS = [
  { label: "Køretøjstype", value: "L2H2 Varevogne" },
  { label: "Drivmiddel", value: "Nye diesel- og elbiler" },
  { label: "Dækning", value: "Hele Danmark (inkl. Bornholm)" },
  { label: "Chauffører", value: "Varebilsbevis & kurser" },
  { label: "Aftaler", value: "Faste transportaftaler" }
];

export const GORDON_PARTNERSHIP_DELIVERIES = [
  {
    category: "Måltidskasser & færdigretter",
    examples: "HelloFresh, BetterFeast, RetNemt, Factor",
    desc: "Præcis og ubrudt kølekædedistribution direkte til modtagere med faste tidsslots og aktiv køl med fokus på stabil temperatur under transporten."
  },
  {
    category: "Fersk kød & slagterivarer",
    examples: "Kødhuset og udvalgte slagterivirksomheder",
    desc: "Skånsom transport under nøje kontrollerede temperaturer, hvor godsets kvalitet bevares intakt."
  },
  {
    category: "Fiskeprodukter & ferskvarer",
    examples: "Maritime grossister & ferskvareleverandører",
    desc: "Aktiv køl med fokus på stabil temperatur under transporten til temperaturkritiske fødevarer."
  },
  {
    category: "Apoteksvarer & medicinalprodukter",
    examples: "Apoteker, klinikker & sundhedssektoren",
    desc: "Sikker håndtering af temperaturfølsom medicin af chauffører med kurser i medicintransport og håndtering af temperaturfølsomt gods."
  }
];

export const DRIVER_QUALIFICATIONS = [
  {
    title: "National varebilschaufførgodkendelse",
    desc: "Alle chauffører opfylder Færdselsstyrelsens lovkrav og besidder officielt chaufføruddannelsesbevis til erhvervsmæssig godskørsel med varebil."
  },
  {
    title: "Køletransport & ubrudt kølekæde",
    desc: "Dokumenterede kurser i temperaturstyring, overvågning, hygiejne og korrekt placering af temperaturfølsomt gods i varerummet."
  },
  {
    title: "Medicintransport & apoteksvarer",
    desc: "Uddannelse i særlige procedurer ved transport af lægemidler, herunder forebyggelse af temperatursving og omhyggelig overdragelse."
  }
];

export const CORE_PILLARS = [
  {
    id: "01",
    title: "Moderne materiel",
    subtitle: "Moderne kølevogne",
    text: "Vores flåde består af nye diesel- og elbiler i L2H2-format. Materiellet er udvalgt og indrettet med ét formål: maksimal driftssikkerhed.",
    icon: "fa-solid fa-truck-ramp-box"
  },
  {
    id: "02",
    title: "Medicinal & køl",
    subtitle: "Fokus på temperaturfølsomt gods",
    text: "Vi har særligt fokus på opgaver, hvor temperaturfølsomhed og pålidelighed er afgørende for godsets integritet.",
    icon: "fa-solid fa-snowflake"
  },
  {
    id: "03",
    title: "Faste samarbejdsaftaler",
    subtitle: "Fokus på faste transportaftaler",
    text: "Vi indgår transportaftaler med virksomheder og leverer til både erhvervs- og privatadresser med faste kørselsplaner.",
    icon: "fa-solid fa-handshake"
  },
  {
    id: "04",
    title: "Stabil kapacitet",
    subtitle: "Forudsigelig drift",
    text: "Med velholdt materiel og professionel styring leverer vi den nødvendige stabilitet i jeres distributionskæde.",
    icon: "fa-solid fa-shield-check"
  }
];

export const FALLBACK_GALLERIES = {
  koeletransport: {
    title: "Køletransport Galleri",
    gallery_slug: "koeletransport",
    description: "Temperaturkontrolleret transport med moderne L2H2 kølevogne og hygiejnisk indrettet varerum til faste erhvervsaftaler.",
    images: [
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/img-3502-scaled.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/1782895557011.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2654580061.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/gordon-elfordon425-3.jpg"
    ]
  },
  medicinaltransport: {
    title: "Medicinaltransport Galleri",
    gallery_slug: "medicinaltransport",
    description: "Dedikerede køretøjer og professionel transport for medicinalindustrien og virksomheder med høje krav til materiel.",
    images: [
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2487533651.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2602712947.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/1782895557011.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2243452699.jpg"
    ]
  },
  foedevaretransport: {
    title: "Fødevaretransport Galleri",
    gallery_slug: "foedevaretransport",
    description: "Pålidelig køle- og fødevaretransport til producenter, måltidskassevirksomheder og distributionspartnere.",
    images: [
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2664143269.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/img-4141.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/img-3502-scaled.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-1770826502.jpg"
    ]
  },
  koeretoejer: {
    title: "Vores Køretøjer Galleri",
    gallery_slug: "koeretoejer",
    description: "Flåde af moderne L2H2 kølevogne med fokus på driftssikkerhed og professionel præsentation.",
    images: [
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/img-3502-scaled.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/gordon-elfordon425-3.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/bornholmslinjen.jpeg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/shutterstock-2654580061.jpg",
      "https://assets.auxodev.dk/assets/ac8ce1b6-e4be-4439-9ce6-53c89a29cb07/1782895557011.jpg"
    ]
  }
};
